define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class AppointmentFiltersService used to manage filters functions, constants and store current used filters
     */
    function AppointmentFiltersService() {
        var self = this;

        var currentFilters = [];
        self.saved = false;

        // Possible values for params associated to filter with multiple closed choice value
        var PARAMS_VALUES = {
            network: [],
            market: [],
            purpose:[],
            treated: []
        };

        self.initFiltersValues = function initFiltersValues(networks) {
            PARAMS_VALUES.network = networks.reduce((acc, network) => {
                    acc.push(network.id);
                    return acc;
                }, []);
        }

        self.initFiltersTreatedValues = function initFiltersValues(treated) {
            PARAMS_VALUES.treated = treated.reduce((acc, t) => {
                acc.push(t.id);
                return acc;
            }, []);
        }

        // name of filters to save
        self.filtersList = [
            'networkFilter',
            'marketFilter',
            'dateStartFilter',
            'dateEndFilter',
            'departmentFilter',
            'purposeFilter',
            'stateFilter',
            'supplierFilter',
            'treatedFilter',
            'csFilter',
            'csdFilter',
            'teleproFilter',
            'rdsFilter',
            'formerRDSFilter',
        ];

        // Default filters based on their type
        self.getDefaultFilter = function getDefaultFilter(type, length) {
            switch (type) {
                case 'boolean':
                    return Array.apply(null, Array(length)).map(function() {
                        return false;
                    });
                    break;
                case 'integer':
                    return null;
                    break;
                case 'string':
                    return null;
                    break;
                case 'date':
                    return null;
                    break;
                case 'dateInterval':
                    return Array.apply(null, Array(length)).map(function() {
                        return null;
                    });
                    break;
                default:
                    console.error('Error on init default filter');
                    break;
            }
        };

        // Filters options
        self.dateUpdatedOptions = {
            showWeeks: true,
            startingDay: 1, // Monday
            maxMode: 'month'
        };


        /**
         * Save current filters used on the orders
         * @param  {Array} filters filters sent
         * @return
         */
        self.saveFilters = function saveFilters(filters) {
            currentFilters = filters;
            self.saved = true;
            return;
        };

        /**
         * @return {Object} current filters object
         */
        self.getFilters = function getFilters() {
            return currentFilters;
        };

        /**
         * Reset current stored filters
         */
        self.clearFilters = function clearFilters() {
            currentFilters = [];
            self.saved = false;
            return;
        };

        /**
         * get a filter value from a UI filter array
         * @param  [Array] filter
         * @return {value}
         */
        self.applyFilter = function applyFilter(filter, paramName) {
            return filter.indexOf(true) !== -1 ? PARAMS_VALUES[paramName][filter.indexOf(true)] : null;
        };

        /**
         * Returns list of references values with truth index in the filter
         * @param  {Array} filter filter to apply
         * @param  {Array} values list of reference values
         * @return {Array}
         */
        self.applyMultipleFilterValues = function applyMultipleFilterValues(filter, values) {
            if (typeof values === 'string') {
                values = PARAMS_VALUES[values];
            }
            return values.filter(function(value, index) {
                // filter using index of filters Array
                return filter[index];
            });
        };

        /**
         * Format Date value according to a filter
         * @param  {Date} dateFilter filter date from the UI
         * @return {String} Formatted string YYYY-MM-DD
         */
        self.applyFullDateFilter = function applyFullDateFilter(dateFilter) {
            return dateFilter ? moment(dateFilter).format('YYYY-MM-DD') : null;
        };

        /**
         * Format Date value according to a filter
         * @param  {Date} dateFilter filter date from the UI
         * @return {String} Formatted string YYYY-MM
         */
        self.applyMonthDateFilter = function applyMonthDateFilter(dateFilter) {
            return dateFilter ? moment(dateFilter).format('YYYY-MM') : null;
        };


        self.toggle = function toggle(isOpen) {
            return !isOpen;
        };

        return self;
    }

    AppointmentFiltersService.$inject = ['orderTypeService'];

    angular.module('app.prospection.store.appointmentFiltersService', []).factory('appointmentFiltersService', AppointmentFiltersService);
});
